import { Routes } from '@angular/router';
import { SecurityLoaders } from '@cfg/security/loaders';
import { HomeComponent } from './dashboard/pages/home/home.component';
import { AccessDeniedComponent } from './shared/pages/access-denied/access-denied.component';

/**
 * Rutas de la aplicación
 */
export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    title: 'Home',
    component: HomeComponent,
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'dashboard',
    loadChildren: () =>
    import('./dashboard/dashboard.routes').then((s) => s.dashboardRoutes)
    //,canActivate: SecurityLoaders.loadGuards()
  }, 
  {
    path: 'access-denied',
    title: 'Access Denied',
    component: AccessDeniedComponent
  }
];
